import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { FieldArrayType, FieldGroupTypeConfig, FieldType, FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { QuillModule } from "ngx-quill";
import { WebServiceLayoutMetadata } from '../../../../model/dyn-form/form-metadata/layout/webservice-layout-metadata.model';

@Component({
    selector: 'app-webservice-type',
    templateUrl: './webservice-type.component.html',
    styleUrl: './webservice-type.component.scss',
    standalone: true,
    imports: [
    CommonModule,
    FormlyModule, FormlyMaterialModule,
    QuillModule
]
})
export class WebserviceTypeComponent extends FieldType<FieldGroupTypeConfig> {

    displayError = signal<boolean | null>(null)

    ngOnInit(): void {
        this.field.props['showError'] = this.displayError
        
        if (this.field.model) {
            this.initMapping()
        }
    }

    initMapping() {

        if (this.props['mappingData'] == undefined) {
            return
        }

        let isError = true

        if (Array.isArray(this.field.model) || typeof this.field.model !== 'object' || Object.keys(this.field.model).length == 0) {
            this.displayError.set(true)
        }

        for (let action of this.props['mappingData'].action) {
            if (this.field.form?.value[<string> this.props['mappingData'].doAction] === action.value) {
                this.displayError.set(false)
                isError = false
                break;
            }
        }

        if (isError) {
            this.displayError.set(true)
        }

    }

    metadata(): WebServiceLayoutMetadata {
        let field: any = this.field
        if (field['metadata'] == null) {
            return <WebServiceLayoutMetadata> {
                name: 'unm',
                description: 'unm3',
                titleError: 'error',
                descriptionError: 'descError'
            }
        }
        return field['metadata']
    }

}
